export const environment = {
  firebase: {
    apiKey: "AIzaSyA20L5lV9SvRD9nE_OBF5wlfpiewoPCWnY",
    authDomain: "recogera-prod.firebaseapp.com",
    databaseURL: "https://recogera-prod-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "recogera-prod",
    storageBucket: "recogera-prod.firebasestorage.app",
    messagingSenderId: "1063165209422",
    appId: "1:1063165209422:web:a97745b77020eebdb44c1f",
    measurementId: "G-TLJCXZQV0D"
  },
  cfBase: 'https://europe-west1-recogera-prod.cloudfunctions.net/',
  production: true,
  id: 'prod',
  region: 'europe-west1',
  version: '0.5.0',
  buildNumber: '',
  emulatorHost: 'localhost',
  webClientId: '1063165209422-889e5orkecoap3bb4o4nc5suf93qumqk.apps.googleusercontent.com',
  features: { studentGamification: false },
};
